import * as THREE from 'three'
import Camera from './Camera'
import Scene from './Scene'
import Controller from './Controller'

export default class Renderer {
  private renderer: THREE.WebGLRenderer
  private animationId: number = 0
  public constructor(
    canvas: HTMLCanvasElement,
    private readonly scene: Scene,
    private readonly camera: Camera,
    private readonly controller: Controller
  ) {
    this.renderer = new THREE.WebGLRenderer({
      alpha: true,
      antialias: true,
      preserveDrawingBuffer: true,
      canvas: canvas
    })
    this.renderer.setSize(320, 320)
    this.renderer.setClearColor(0xffffff, 1.0) // 背景色を白に設定。
    this.renderer.shadowMap.enabled = true // 影の描画を有効にする。
  }

  public resize(width: number, height: number): void {
    this.renderer.setSize(width, height)
  }

  public update(): void {
    this.renderer.clear()
    this.renderer.render(this.scene.scene, this.camera.camera)
  }

  public start(): void {
    let animationFrame = 0
    let fps = 30
    const loop = (): void => {
      this.animationId = requestAnimationFrame(loop)
      animationFrame++
      if (animationFrame % (60 / fps) !== 0) {
        return
      }
      // console.log('anim ' + this.animationId)
      animationFrame = 0
      this.update()
      this.controller.update()
    }
    loop()
  }
  public stop(): void {
    if (this.animationId > 0) {
      cancelAnimationFrame(this.animationId)
      this.animationId = 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Renderer.ts